/**
 * Created by mrocha on 8/16.
 */

import fabric           from  'fabric.js/dist/fabric.require';

//======================================================================================
// Create a 'rectangle' shape
// Targets Behaviors and Workflow canvases.
//======================================================================================
export const RectangleWithTextClass = fabric.util.createClass(fabric.Rect, {

    type: 'start',

    initialize: function(opt) {
        const options = opt || {};
        const widgetWidth = 150;
        const widgetHeight = 100;

        this.callSuper('initialize', options);
        this.set('label', options.label || '');
        this.set('icon',  options.icon  || '');

        this.icon = this.icon || '';
        this.fillColor = options.fillColor || '#FFFFFF';

        this.width  = Number(options.width || widgetWidth);
        this.height = Number(options.height || widgetHeight);

        this.left = Number(this.left) - this.width /2;
        this.top  = Number(this.top)  - this.height/2;

        this.hasControls = true;
        this.hasRotatingPoint = false;
        this.objectCaching = false;
        this.visible = options.visible;
        this.hoverCursor = 'pointer';
    },

    toObject: function() {
        return fabric.util.object.extend(this.callSuper('toObject'), {
            label: this.get('label')
        });
    },

    // TODO pull this up or move it into a utility. It is duplicated in LabeledRectClass
    wrapText: function(context, originalText, x, originalY, lineHeight) {
        const widgetHeight = parseInt(this.height);
        const widgetWidth = parseInt(this.width);
        let textTrimmed = [''];
        let aText = [];
        originalText.split('\n').forEach((o)=>{
            aText.push(...o.split(' '));
            aText.push('\n');
        });

        let textLength = 0;
        let lines = 0;
    
        for (let i=0, len=aText.length ; i<len ; i++) {
            if (aText[i] === '\n') {
                lines++;
                textTrimmed[lines] = '\n';
            } else {
                textLength = context.measureText( textTrimmed[lines]+aText[i] );
                if (textLength.width > widgetWidth - 20) {
                    let singleLineMeasure = context.measureText( aText[i] );
                    // single lines longer than 
                    if (singleLineMeasure.width > widgetWidth-20) {
                        lines = this._processBigSingleLine(aText[i], singleLineMeasure.width, lines, textTrimmed, widgetWidth);
                        continue;
                    } else {
                        lines++;
                        textTrimmed[lines] = '';
                    }
                }
                textTrimmed[lines] += aText[i] + ' ';
            }
        }

        let linesAvailable = Math.floor(widgetHeight/lineHeight);
        linesAvailable = linesAvailable > lines ? lines : linesAvailable;
        const startingPointY = - (linesAvailable*lineHeight)/2;

        for (var i=0 ; i<linesAvailable ; i++) {
            if ((i+1) === linesAvailable && linesAvailable < lines) {
                textTrimmed[i] += '...';
                this.textOverflown = true;
            } else {
                this.textOverflown = false;
            }
            context.fillText(textTrimmed[i], -(widgetWidth/2) + 5, startingPointY + (lineHeight*i));
        }
    },
    _processBigSingleLine: function(_line, lineWidth, lineIndex, textTrimmed, widgetWidth){
        const createLines = Math.floor(lineWidth/(widgetWidth-20)); // todo: check for completeness
        let currentLine = lineIndex,
            smallerText = '',
            newTrimPos = 0,
            line = _line;
        
        for (var ii=0 ; ii<createLines ; ii++) {
            newTrimPos = Math.floor( _line.length * (widgetWidth-20) / lineWidth);
            smallerText = line.substring(0, newTrimPos);
            line = line.substring(newTrimPos, line.length);

            textTrimmed[currentLine] = smallerText;
            currentLine++;
        }
        return --currentLine;
    },
    _render: function(ctx) {
        this.callSuper('_render', ctx);

        // origin (0,0) is at rectangle center
        const
            x = this.width/2,
            y = this.height/2;

        ctx.lineWidth = 0.5;

        ctx.strokeStyle = '#666666';
        ctx.fillStyle  = 'white';
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();

        ctx.font = '12px Sans-Serif';
        ctx.fillStyle = 'black';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'hanging';

        this.wrapText(ctx, this.label, this.left + x, this.height, 17);


        ctx.closePath();
    }
});

